/* Category names, unambiguous prefixes and small typos use existing product tags. */
(() => {
  // Tags are copied from the product CSV. Multiple tags on one product are valid.
  const categories = [
    ['Bileklik', ['bileklik', 'bileklikler', 'bilezik', 'bilezikler', 'bileklik standı', 'bileklik tablası']],
    ['Kolye', ['kolye', 'kolyeler', 'kolyelik', 'kolye standı', 'kolye tablası']],
    ['Küpe', ['küpe', 'küpeler', 'küpelik', 'küpe standı', 'küpe tablası']],
    ['Gözlük', ['gözlük', 'gözlükler', 'gözlüklük', 'gözlük standı']],
    ['Yüzük', ['yüzük', 'yüzükler', 'yüzüklük', 'yüzük standı', 'yüzük tablası']],
    ['Kelepçe', ['kelepçe', 'kelepçeler', 'kelepçelik']],
    ['Saat', ['saat', 'saatler', 'saat standı']],
    ['Piercing', ['piercing', 'pirsing']],
    ['tragus', ['tragus']],
    ['halhal', ['halhal', 'halhallar']],
    ['Hızma', ['hızma', 'hızmalar']],
    ['Taç', ['taç', 'taçlar']],
    ['Toka', ['toka', 'tokalar']],
    ['tespih', ['tespih', 'tesbih']],
    ['Zincirlik', ['zincirlik', 'zincir', 'zincir askısı']],
    ['Deri Bileklik', ['deri bileklik', 'deri bileklikler']],
    ['Kutular', ['kutu', 'kutular', 'takı kutusu', 'takı kutuları']],
    ['Manken', ['manken', 'mankenler']],
    ['Rulo Stantlar', ['rulo', 'rulo stant', 'rulo stand', 'rulo standı', 'rulo stantlar', 'rulo standlar']],
    ['Sabit Standlar', ['sabit stant', 'sabit stand', 'sabit standlar', 'sabit stantlar', 'sabit standı']],
    ['Stant Aparatları', ['stant aparatı', 'stand aparatı', 'stant aparatları', 'stand aparatları']],
    ['Masaüstü Aksesuar Standları', ['masaüstü aksesuar', 'masaüstü aksesuar standları', 'masaüstü aksesuar stantları']],
    ['Orta Dekor', ['orta dekor']],
    ['Bijuteri Dekor', ['bijuteri', 'bijuteri dekor']],
    ['İthal Ürünler', ['ithal', 'ithal ürün', 'ithal ürünler']],
    ['En Yeni Ürünler', ['en yeni', 'en yeni ürünler', 'yeni ürünler']],
    ['düzenleyici', ['düzenleyici', 'takı düzenleyici', 'takı düzenleyiciler']],
    ['paketleme', ['paketleme']],
    ['Doğal Taş', ['doğal taş']],
    ['taş dekor', ['taş dekor']],
  ];

  function normalize(value) {
    return value.trim().toLocaleLowerCase('tr-TR').normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/\s+/g, ' ');
  }

  const aliases = categories.flatMap(([tag, words]) => words.map(word => [normalize(word), tag]));

  // A missing, extra or wrong letter, or one pair of transposed letters.
  function oneTypoApart(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) {
      const differences = [];
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) differences.push(i);
      if (differences.length <= 1) return true;
      if (differences.length !== 2) return false;
      const [i, j] = differences;
      return j === i + 1 && a[i] === b[j] && a[j] === b[i];
    }
    const shorter = a.length < b.length ? a : b;
    const longer = a.length < b.length ? b : a;
    let i = 0;
    while (i < shorter.length && shorter[i] === longer[i]) i++;
    return shorter.slice(i) === longer.slice(i + 1);
  }

  function uniqueTag(matches) {
    const tags = [...new Set(matches.map(([, tag]) => tag))];
    return tags.length === 1 ? tags[0] : null;
  }

  function queryForTag(tag) {
    return tag === 'Bileklik'
      ? '(tag:"Bileklik" OR tag:"Deri Bileklik")'
      : `tag:"${tag}"`;
  }

  function toQuery(value) {
    const term = normalize(value);
    // Never reinterpret SKU numbers or explicit Shopify search syntax.
    if (!term || /[\d:"()]/.test(term)) return value;
    const exact = aliases.find(([word]) => word === term);
    if (exact) return queryForTag(exact[1]);
    // These words describe many categories; do not turn them into one tag.
    if (['stand', 'stant', 'taki', 'aksesuar'].includes(term)) return value;
    if (term.length < 3) return value;
    const prefixes = aliases.filter(([word]) => word.startsWith(term));
    const prefixTag = uniqueTag(prefixes);
    if (prefixTag) return queryForTag(prefixTag);
    if (prefixes.length || term.length < 5) return value;
    const tag = uniqueTag(aliases.filter(([word]) => oneTypoApart(term, word)));
    return tag ? queryForTag(tag) : value;
  }

  function displayTerm(value) {
    const plainValue = value.replace(/&quot;/g, '"');
    for (const [tag] of categories) {
      if (plainValue === queryForTag(tag) || plainValue === `tag:"${tag}"`) return tag.toLocaleLowerCase('tr-TR');
    }
    return value;
  }

  window.MDSearchRules = { toQuery, displayTerm };

  function isProductSearch(url) {
    const root = window.Shopify?.routes?.root || '/';
    return url.origin === window.location.origin && url.pathname === `${root}search`
      && (!url.searchParams.has('type') || url.searchParams.get('type') === 'product');
  }

  // Covers the header, mobile search, results form and dynamically inserted forms.
  // FormData changes the submitted query without replacing the visible input text.
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, window.location.href);
    const type = event.formData.get('type');
    if (!isProductSearch(url) || (type && type !== 'product')) return;
    const query = event.formData.get('q');
    if (typeof query !== 'string') return;
    const scopedQuery = toQuery(query);
    if (scopedQuery !== query) {
      event.formData.set('q', scopedQuery);
      event.formData.set('type', 'product');
    }
  });

  // Also covers bookmarks and existing trending-search links using plain words.
  const currentURL = new URL(window.location.href);
  if (isProductSearch(currentURL)) {
    const query = currentURL.searchParams.get('q');
    if (query && toQuery(query) !== query) {
      currentURL.searchParams.set('q', toQuery(query));
      currentURL.searchParams.set('type', 'product');
      currentURL.searchParams.delete('page');
      window.location.replace(currentURL.toString());
    }
  }
})();
